import { User } from "api";
import { withErrorBoundary, GoogleStaticMap} from "shared";
import { SmartButtonStub } from "ui/smart-buttons";
import "react-phone-number-input/style.css";
import Input from "react-phone-number-input/input";
import GuestSignupForm from "./GuestSignupForm";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { useEffect, useState } from "react";

const LoginPage = () => {
  // State
  const [state, setState] = useState({ userforgotPasswordLink: "", email: "", password: "", homeAddress: "", phoneNumber: "", showRegisterHomeForm: false, showSignUpForm: false, signupPhone: "", signupAddress: "", showLoginForm: false, loginError: null, verificationError: null, homeLat: null, homeLng: null, activeForm: "registerHome" })

  // Consts

  // Custom Methods
  const renderRightPane = () => {
    return (
      <>
        <div className="text-center mb-4">
          <SmartButtonStub
            text="Register Your Home"
            buttonType="button"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            click={() =>
              setState(prev => ({
                ...prev,
                verificationError: null,
                showSignUpForm: false,
                signupSuccess: false,
                userForgotPasswordLink: "",
                activeForm: "registerHome",
                showRegisterHomeForm: !state.showRegisterHomeForm,
                loginError: null,
              }))
            }
          />
          <SmartButtonStub
            text="Register as a Guest"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            buttonType="button"
            click={() =>
              setState(prev => ({
                ...prev,
                verificationError: null,
                userForgotPasswordLink: "",
                signupSuccess: false,
                activeForm: "signUp",
                showSignUpForm: !state.showSignUpForm,
              }))
            }
          />

          <SmartButtonStub
            text="Sign In"
            buttonType="button"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            click={() =>
              setState(prev => ({
                ...prev,
                verificationError: null,
                userForgotPasswordLink: "",
                activeForm: "login",
                signupSuccess: false,
                showLoginForm: !state.showLoginForm,
              }))
            }
          />
        </div>

        {state.activeForm === "registerHome" &&
          renderRegisterHomeForm()}
        {state.activeForm === "signUp" && (
          <div className="px-4 mt-3">
            <GuestSignupForm
              onSuccess={() => setState(prev => ({ ...prev, signupSuccess: true, activeForm: 'login' }))}
            />
          </div>
        )}
        { state.signupSuccess && <p className="alert alert-success text-center">
            {App.isBigSky
              ? "Thank you for registering! Please check your email for additional welcome information and credentials."
              : "Thank you for registering! Please Sign In to activate your account."}
          </p>
        }
        {state.activeForm === "login" && renderSignInForm()}
      </>
    );
  }

  const renderSignInForm = () => {
    return (
      <div className="px-4 mt-3 custom-text-community">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 px-4">
            {state.loginError && (
              <p className="alert alert-danger mt-2" style={{ fontSize: '17px' }}>
                {state.loginError}
              </p>
            )}
            {state.userForgotPasswordLink && (
              <p className="alert alert-info mt-2 text-center" style={{ fontSize: '17px' }}>
                <a href="/u/password/new" target="_blank" rel="noopener noreferrer">
                  Click here to reset your password
                </a>
              </p>
            )}
          </div>
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={state.email}
            onChange={inputChanged}
            id="email"
            aria-label="Email address"
            autocomplete="email"
            style={{
              border: "2px solid #2C2C2C",
              borderRadius: "4px",
              color: "#000000",
              backgroundColor: "#FFFFFF",
              padding: "0.5rem"
            }}
          />
        </div>

        <div className="form-group mt-2">
          <label>Password</label>
          <input
            type="password"
            name="password"
            className="form-control"
            value={state.password}
            onChange={inputChanged}
            id="password"
            aria-label="Password"
            autocomplete="new-password"
            style={{
              border: "2px solid #2C2C2C",
              borderRadius: "4px",
              color: "#000000",
              backgroundColor: "#FFFFFF",
              padding: "0.5rem"
            }}
          />
        </div>

        <div className="mt-3 d-flex justify-content-end">
          <SmartButtonStub
            text="Login"
            buttonType="button"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            click={logIn}
          />
        </div>
      </div>
    );
  }

  const renderRegisterHomeForm = () => {
    const { showSignUpForm, verificationError, homeAddress, phoneNumber, homeLat, homeLng, signupAddress, signupPhone, userforgotPasswordLink } = state;

    if (!showSignUpForm) {
      return (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 px-4">
              {verificationError && (
                <p className="alert alert-danger mt-2 text-center">
                  {verificationError}
                </p>
              )}

              {userforgotPasswordLink && (
                <p className="alert alert-info mt-2 text-center">
                  <a href='/u/password/new' target="_blank" rel="noopener noreferrer">
                    Click here to reset your password
                  </a>
                </p>
              )}

              <div className="form-group">
                <label className="fw-bold custom-text-community">
                  {App.isBigSky ? "Zip Code" : "Street Address"}
                </label>
                <GooglePlacesAutocomplete
                  apiKey={App.googleApiKey}
                  placeholder="Please Enter Your Street Address"
                  selectProps={{
                    onChange: (place) => {
                      const description = place?.label;
                      if (!description) return;
                      setState(prev => ({ ...prev, homeAddress: description }))
                      geocodeAddress(description);
                    },
                  }}
                />
              </div>

              <div className="form-group mt-2">
                <label
                  htmlFor="signup--phone"
                  className="fw-bold custom-text-community"
                  style={{ color: '#000000' }}
                >
                  Phone Number
                </label>
                <Input
                  placeholder="Please Enter Your Phone Number"
                  type="tel"
                  country="US"
                  international
                  withCountryCallingCode
                  maxLength={15}
                  className="form-control"
                  id="signup--phone"
                  name="phone"
                  value={phoneNumber}
                  onChange={(value) => setState(prev => ({ ...prev, phoneNumber: value }))}
                  style={{
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    border: '2px solid #2C2C2C',
                    borderRadius: '4px',
                    padding: '0.5rem',
                  }}
                />
              </div>

              <div className="mt-3 d-flex justify-content-end">
                <SmartButtonStub
                  text="Verify My Information"
                  buttonType="button"
                  className="primary custom-font-size custom-font-family mb-1 mb-md-0"
                  click={verifyHomeInfo}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="px-4 mt-3">
          <div className="d-flex flex-wrap">
            <div className="col-12 col-md-6 mb-4">
              <GuestSignupForm
                onSuccess={() => setState(prev => ({ ...prev,  signupSuccess: true, activeForm: 'login' }))}
                verificationError={verificationError}
                signupAddress={signupAddress}
                signupPhone={signupPhone}
                disableAddress={true}
              />
            </div>

            <div className="col-12 col-md-6 mb-4">
              <h6>Address Preview:</h6>
              <GoogleStaticMap
                address={signupAddress}
                defaultCenter={{ lat: homeLat, lng: homeLng }}
                defaultZoom={14}
              />
            </div>
          </div>
        </div>
      );
    }
  }

  const geocodeAddress = async (address) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === "OK") {
        const location = results[0].geometry.location;
        setState(prev => ({ ...prev, homeLat: location.lat(), homeLng: location.lng()}));
      } else {
        console.error("Geocoding failed:", status);
      }
    });
  };

  const verifyHomeInfo = async () => {
    const { phoneNumber } = state;
    const addressVal = document.querySelector(".google-places-autocomplete__input")?.value
    geocodeAddress(addressVal);
    setState(prev => ({ ...prev, homeAddress: addressVal}));

    if (!addressVal) {
      setState(prev => ({ ...prev, verificationError: "Please enter address"}));
      return;
    }

    if (!phoneNumber) {
      setState(prev => ({ ...prev, verificationError: "Please enter Phone Number"}));
      return;
    }

    const phoneObj = parsePhoneNumberFromString(phoneNumber, 'US');
    if (!phoneObj || !phoneObj.isValid() || phoneObj.country !== 'US' || phoneObj.getType() === 'UNKNOWN') {
      setState(prev => ({ ...prev, verificationError: "Please enter a valid and real US phone number"}));
      return;
    }

    setState(prev => ({ ...prev,  verificationError: null }));

    try {
      const res = await Backend.post("/users/verify_home", {
        address: addressVal,
        phone: phoneNumber,
      });

      const { addressExists, phoneExists, forgotPasswordLink } = res;

      if (addressExists && phoneExists) {
        setState(prev => ({
          ...prev,
          verificationError: `Please note, your account has already been created. If you need to reset your password, please do so at this link: `,
          userforgotPasswordLink: forgotPasswordLink,
          showRegisterHomeForm: false,
          showSignUpForm: false,
        }));
      } else if (addressExists) {
        setState(prev => ({
          ...prev,
          verificationError: `Please note, your address has already been claimed. Your account will be added as a family profile account.`,
          userforgotPasswordLink: "",
          showSignUpForm: true,
          signupAddress: addressVal,
          signupPhone: phoneNumber,
        }));
      } else {
        setState(prev => ({
          ...prev,
          verificationError: null,
          userforgotPasswordLink: "",
          showSignUpForm: true,
          signupAddress: addressVal,
          signupPhone: phoneNumber,
        }));
      }
    } catch (err) {
      console.error(err);
      setState(prev => ({ ...prev, verificationError: "Something went wrong while verifying. Please try again."}));
    }
  };

  const logIn = async () => {
    const { email, password } = state;
    setState(prev => ({ ...prev,  loginError: null }));

    doLogin("/auth", { email, password, device_type: "browser"});
  };

  const doLogin = async (url, params) => {
    try {
      let res = await Backend.post(url, params);
      console.info("auth as", res.user);
      User.signIn(res.user);
      setState(prev => ({ ...prev,  loginError: null, userForgotPasswordLink: '' }));
      window.location = "/app";
    } catch (xhr) {
      console.warn("auth failed", xhr);
      if (xhr.status >= 400 && xhr.status < 500) {
        const message = xhr.responseJSON.message;
        if (message === 'Please check your password and try again.') {
          setState(prev => ({
            ...prev,
            loginError: 'The password you entered is incorrect. If you need to reset your password, please do so at this link:',
            userForgotPasswordLink: '/u/password/new'
          }));
          console.log("Setting forgot password link");
        } else {
          setState(prev => ({ ...prev, loginError: message, userForgotPasswordLink: '' }));
        }
      } else {
        setState(prev => ({ ...prev, loginError: "Something went wrong. Please try again."}));
      }
    }
  };

  const inputChanged = (e) => {
    const { name, value } = e.target;
    setState(prev => ({ ...prev, [name]: value, error: null, loginError: null, verificationError: null}));
  };

  const applyGooglePlacesAccessibilityFix = () => {
    const input = document.querySelector("#react-google-places-autocomplete-input");
    if (input) {
      input.setAttribute("autocomplete", "street-address");
      input.setAttribute("id", "home-address");
      input.setAttribute("name", "street-address");
      input.setAttribute("aria-label", "Street Address");
      input.style.border = "2px solid #2C2C2C";
      input.style.borderRadius = "4px";
      input.style.color = "#000000";
      input.style.backgroundColor = "#FFFFFF";
      input.style.padding = "0.5rem";
    }
  };

  const loadSettings = async () => {
    try {
      const settings = await Backend.get("/signup_settings");
      setState(prev => ({ ...prev, settings }));
    } catch (err) {
      console.error("Failed to load signup settings:", err);
    }
  };

  // Hooks

  useEffect(() => {
    loadSettings();
    setTimeout(applyGooglePlacesAccessibilityFix, 100);
  }, [])

  useEffect(() => {
    applyGooglePlacesAccessibilityFix();
  }, [state.showRegisterHomeForm])

  // render
  return (
    <div className="LoginModal">
      <div className="top d-block">
        <div className="top-overlay"></div>
      </div>
      <div className="bottom">{renderRightPane()}</div>
    </div>
  );
}

export default withErrorBoundary(LoginPage);
